import { Action } from '@ngrx/store';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { ErrorMessage } from '../../util/error.interface';
import { EInvoice, EInvoiceFilter, EInvoicesFromMW } from '../../interfaces/e-invoice.interface';

export const CLEAR_E_INVOICES_FILTER = 'invoice:CLEAR_E_INVOICES_FILTER';
export const QUERY_E_INVOICES_START = 'invoice:QUERY_E_INVOICES_START';
export const QUERY_E_INVOICES_SUCCESS = 'invoice:QUERY_E_INVOICES_SUCCESS';
export const QUERY_E_INVOICES_FAIL = 'invoice:QUERY_E_INVOICES_FAIL';

export const E_INVOICE_DOWNLOAD_PDF = 'invoice:E_INVOICE_DOWNLOAD_PDF';
export const E_INVOICE_DOWNLOAD_PDF_SUCCESS = 'invoice:E_INVOICE_DOWNLOAD_PDF_SUCCESS';
export const E_INVOICE_DOWNLOAD_PDF_FAIL = 'invoice:E_INVOICE_DOWNLOAD_PDF_FAIL';

export const E_INVOICE_DOWNLOAD_LIST = 'invoice:E_INVOICE_DOWNLOAD_LIST';
export const E_INVOICE_DOWNLOAD_LIST_SUCCESS = 'invoice:E_INVOICE_DOWNLOAD_LIST_SUCCESS';
export const E_INVOICE_DOWNLOAD_LIST_FAIL = 'invoice:E_INVOICE_DOWNLOAD_LIST_FAIL';

export interface BlobAction extends Action {
  readonly payload: { blob: Blob; filename: string };
}

export class ClearInvoicesFilterAction implements Action {
  readonly type = CLEAR_E_INVOICES_FILTER;
}

export class QueryEInvoicesStartAction implements Action {
  readonly type = QUERY_E_INVOICES_START;
  logPayload = true;

  constructor(readonly payload: { filter: EInvoiceFilter }) {}
}

export class QueryEInvoicesSuccessAction implements Action {
  readonly type = QUERY_E_INVOICES_SUCCESS;

  constructor(readonly payload: { filter: EInvoiceFilter; invoices: EInvoicesFromMW; customers: Customer[] }) {}
}

export class QueryEInvoicesFailAction implements Action {
  readonly type = QUERY_E_INVOICES_FAIL;
  logPayload = true;

  constructor(readonly payload: { errorMessage: ErrorMessage }) {}
}

export class EInvoiceDownloadPdfAction implements Action {
  readonly type = E_INVOICE_DOWNLOAD_PDF;
  logPayload = true;

  ui = {
    id: E_INVOICE_DOWNLOAD_PDF,
    busy: true,
  };

  constructor(readonly payload: { eInvoice: EInvoice }) {}
}

export class EInvoiceDownloadPdfSuccessAction implements BlobAction {
  readonly type = E_INVOICE_DOWNLOAD_PDF_SUCCESS;

  ui = {
    id: E_INVOICE_DOWNLOAD_PDF,
    busy: false,
  };

  constructor(readonly payload: { blob: Blob; filename: string }) {}
}

export class EInvoiceDownloadPdfFailAction implements Action {
  readonly type = E_INVOICE_DOWNLOAD_PDF_FAIL;
  logPayload = true;

  ui = {
    id: E_INVOICE_DOWNLOAD_PDF,
    busy: false,
  };

  constructor(readonly payload: Error) {}
}

export class EInvoiceDownloadListAction implements Action {
  readonly type = E_INVOICE_DOWNLOAD_LIST;

  ui = {
    id: E_INVOICE_DOWNLOAD_LIST,
    busy: true,
  };

}

export class EInvoiceDownloadListSuccessAction implements BlobAction {
  readonly type = E_INVOICE_DOWNLOAD_LIST_SUCCESS;

  ui = {
    id: E_INVOICE_DOWNLOAD_LIST,
    busy: false,
  };

  constructor(readonly payload: { blob: Blob; filename: string }) {}
}

export class EInvoiceDownloadListFailAction implements Action {
  readonly type = E_INVOICE_DOWNLOAD_LIST_FAIL;
  logPayload = true;

  ui = {
    id: E_INVOICE_DOWNLOAD_LIST,
    busy: false,
  };

  constructor(readonly payload: Error) {}
}

export type Actions =
  | QueryEInvoicesStartAction
  | QueryEInvoicesSuccessAction
  | QueryEInvoicesFailAction
  | ClearInvoicesFilterAction
  | EInvoiceDownloadPdfAction
  | EInvoiceDownloadPdfSuccessAction
  | EInvoiceDownloadPdfFailAction
  | EInvoiceDownloadListAction
  | EInvoiceDownloadListSuccessAction
  | EInvoiceDownloadListFailAction;
